import { render, staticRenderFns } from "./CardAppleInApp.vue?vue&type=template&id=b3fac5aa&scoped=true"
import script from "./CardAppleInApp.vue?vue&type=script&lang=js"
export * from "./CardAppleInApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fac5aa",
  null
  
)

export default component.exports